import { Link } from "react-router-dom";

interface Props {
  title?: string;
  description?: string;
  onReset?: () => void;
  resetLabel?: string;
  suggestions?: { label: string; to: string }[];
}

export default function EmptyState({
  title = "暂无符合条件的漫画",
  description = "试试调整筛选条件，或回到全部分类浏览最新更新的作品。",
  onReset,
  resetLabel = "重置筛选",
  suggestions,
}: Props) {
  return (
    <div className="rounded-lg border hairline bg-background-900/60 px-5 py-14 text-center">
      <span className="w-14 h-14 mx-auto rounded-full flex items-center justify-center bg-background-800 text-foreground-400">
        <i className="ri-file-search-line text-2xl" />
      </span>
      <h2 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-50">{title}</h2>
      <p className="mt-2 text-xs md:text-sm text-foreground-400 max-w-[460px] mx-auto leading-6">{description}</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-2.5">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="h-9 px-4 rounded-md bg-accent-500 text-background-950 text-xs font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line mr-1" />
            {resetLabel}
          </button>
        )}
        {(suggestions || []).map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="h-9 px-4 rounded-md border hairline text-xs text-foreground-200 flex items-center gap-1.5 hover:border-accent-500/50 hover:text-accent-300 transition-colors whitespace-nowrap"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
}